import { createSortOption } from '@nosto/preact';
export const sizes = [24, 48, 72];

export const sortOptions = [
  createSortOption('score', 'Featured', { field: 'score', order: 'desc' }),
  createSortOption('name', 'Alphabetically (A-Z)', {
    field: 'name',
    order: 'asc',
  }),
  createSortOption('-name', 'Alphabetically (Z-A)', {
    field: 'name',
    order: 'desc',
  }),
  createSortOption('price', 'Price (low to high)', {
    field: 'price',
    order: 'asc',
  }),
  createSortOption('-price', 'Price (high to low)', {
    field: 'price',
    order: 'desc',
  }),
  createSortOption('oldest', 'Newest to Oldest', {
    field: 'datePublished',
    order: 'desc',
  }),
  createSortOption('oldest', 'Oldest to Newest', {
    field: 'datePublished',
    order: 'asc',
  }),
];

export const defaultConfig = {
  sort: sortOptions[0],
  serpSize: sizes[0],
  autocompleteProductsSize: 6,
  autocompleteKeywordsSize: 5,
  historySize: 5,
};
